import "./style.css";
import {spinStore, store} from "../store";
import {isMobile} from "pixi.js";
import {useEffect, useRef} from "react";
import {observer} from "mobx-react";
import {t, TKeys} from "../translationService";
import {getAmountWithCurrency} from "../utilites";

export const showInfoSection = () => document.getElementById("infoSectionWrapper").style.display = "flex";//pixiComponents.infoSectionContainer.visible = true;
export const hideInfoSection = () => document.getElementById("infoSectionWrapper").style.display = "none";//pixiComponents.infoSectionContainer.visible = false;

export const InfoSection = observer(() => {
    console.log(t(TKeys.MAX_BET));
    return <div id={"infoSectionWrapper"} onClick={hideInfoSection}>
        <div className={`infoSection  ${isMobile.phone ? "fullScreenSize" : "infoSectionSize"}`}
             onClick={(e) => e.stopPropagation()}
        >
            <img src={"./assets/singleIcons/close.svg"} id={"infoSectionCloseIcon"} onClick={hideInfoSection}/>
            <div className={"infoSectionTitle"}>{t(TKeys.PAY_TABLE)}</div>
            <div className={"rulesText"}>
                {t(TKeys.PAY_TABLE_DESCRIPTION)}
            </div>
            <div className={`iconsInfoGreed ${isMobile.phone ? "iconsInfoGreedVertical" : "iconsInfoGreedHorizontal"}`}>

                <IconInfoByOdds iconPath={"./assets/singleIcons/icon9.webp"} odds={{12: 50, 10: 30, 8: 10}}/>
                <IconInfoByOdds iconPath={"./assets/singleIcons/icon8.webp"} odds={{12: 20, 10: 10, 8: 3}}/>
                <IconInfoByOdds iconPath={"./assets/singleIcons/icon7.webp"} odds={{12: 15, 10: 4, 8: 2}}/>
                <IconInfoByOdds iconPath={"./assets/singleIcons/icon6.webp"} odds={{12: 12, 10: 2.5, 8: 1.5}}/>
                <IconInfoByOdds iconPath={"./assets/singleIcons/icon5.webp"} odds={{12: 10, 10: 2, 8: 1.2}}/>
                <IconInfoByOdds iconPath={"./assets/singleIcons/icon4.webp"} odds={{12: 8, 10: 1.5, 8: 1}}/>
                <IconInfoByOdds iconPath={"./assets/singleIcons/icon3.webp"} odds={{12: 5, 10: 1.2, 8: 0.5}}/>
                <IconInfoByOdds iconPath={"./assets/singleIcons/icon2.webp"} odds={{12: 4, 10: 0.7, 8: 0.3}}/>
                <IconInfoByOdds iconPath={"./assets/singleIcons/icon1.webp"} odds={{12: 2, 10: 0.5, 8: 0.2}}/>
            </div>
            <div className={"scatterInfoComponentContainer"}>
                <IconInfoByDescription iconPath={"./assets/singleIcons/scatter.webp"}
                                       description={t(TKeys.SCATTER_DESCRIPTION)}/>
            </div>
            <div className={"infoSectionTitle"} style={{marginTop: "45px"}}>{t(TKeys.TUMBLE_FEATURE)}</div>
            <div className={"rulesText"}>{t(TKeys.TUMBLE_FEATURE_DESCRIPTION)}</div>

            <div className={"infoSectionTitle"} style={{marginTop: "45px"}}>{t(TKeys.FREE_SPINS_RULES)}</div>
            <div className={"rulesText"}>{t(TKeys.FREE_SPINS_RULES_DESCRIPTION)}</div>
            <img src={"./assets/singleIcons/multiplayerIcon.webp"} className={"multiplayerIconInfoImage"}/>
            <div className={"rulesText"}>{t(TKeys.MULTIPLIER_SYMBOL_DESCRIPTION)}</div>
            <br/>
            <div className={"game-limits-info-container"}>
                <div className={"game-limits-item"}>RTP - {store.rtp}%</div>
                {store.minBet ? <div className={"game-limits-item"}>{t(TKeys.MIN_BET)} - {store.minBet} {store.currency} </div> : <></>}
                {store.maxBet ? <div className={"game-limits-item"}>{t(TKeys.MAX_BET)} - {store.maxBet} {store.currency} </div> : <></>}
                {store.maxWin ? <div className={"game-limits-item"}>{t(TKeys.MAX_WIN)} - {store.maxWin} {store.currency} </div> : <></>}
                {store.maxOdd ? <div className={"game-limits-item"}>{t(TKeys.MAX_ODD)} - {store.maxOdd} </div> : <></>}
                <br/>
            </div>
        </div>
    </div>
})

const IconInfoByOdds = observer(({iconPath, odds}) => {
    return <div className={"iconInfoContainer"}>
        <img src={iconPath}/>
        <div className={"oddsList"}>

            <div>{`12+ ${(spinStore.spinAmount * odds[12]).toFixed(2)}  ${store.currency}`}</div>
            <div>{`10-11 ${(spinStore.spinAmount * odds[10]).toFixed(2)}  ${store.currency}`}</div>
            <div>{`8-9 ${(spinStore.spinAmount * odds[8]).toFixed(2)} ${store.currency}`}</div>
            {/*{Object.keys(odds).reverse().map((key) => {*/}
            {/*    return <div key={key}>{`${key} - ${spinStore.spinAmount * odds[key]} ${store.currency}`}</div>*/}
            {/*})}*/}
        </div>
    </div>
})

const IconInfoByDescription = ({iconPath, description}) => {
    return <div className={"scatterInfoContainer"}>
        <img src={iconPath}/>
        <div className={"description"}>{description}
            <br/> 4 - {(spinStore.spinAmount * 3).toFixed(2)} {store.currency}
            <br/> 5 - {(spinStore.spinAmount * 5).toFixed(2)} {store.currency}
            <br/> 6+ - {(spinStore.spinAmount * 100).toFixed(2)} {store.currency}
        </div>
    </div>
}
